import { jsx as s } from "react/jsx-runtime";
import { forwardRef as g, useContext as v, Children as w } from "react";
import { Paragraph as b } from "../../../atoms/Paragraph/Paragraph.es.js";
import { Button as k } from "@chakra-ui/react";
import { c as D, u as F, e as h } from "../../../floating-ui.react-5e63cf1f.js";
import { useDropdownContext as A, DropdownContext as P, useDropdownStyle as R } from "../Dropdown.context.es.js";
const M = g(
  ({ __css: i, children: m, disabled: c, active: u, trackId: a, ...t }, d) => {
    const { activeIndex: f, getItemProps: l } = A(), r = D(), x = v(P), o = F(), y = r.index === f, C = R(), I = w.map(m, (e) => typeof e == "string" || typeof e == "number" ? /* @__PURE__ */ s(b, { size: "md", as: "span", children: e }) : e);
    return /* @__PURE__ */ s(
      k,
      {
        __css: { ...C.item, ...i },
        as: "button",
        ref: h([r.ref, d]),
        type: "button",
        role: "menuitem",
        tabIndex: y ? 0 : -1,
        disabled: c,
        isActive: u,
        variant: "unstyled",
        "track-id": a,
        ...t,
        ...l({
          onClick(e) {
            var n;
            (n = t.onClick) == null || n.call(t, e), o == null || o.events.emit("click");
          },
          onFocus(e) {
            var n;
            (n = t.onFocus) == null || n.call(t, e), x.setHasFocusInside(!0);
          }
        }),
        children: I
      }
    );
  }
);
export {
  M as DropdownItem
};
//# sourceMappingURL=DropdownItem.es.js.map
